module.exports = __webpack_public_path__ + "static/img/4.32533efd.png";